// First import: records the cross-domain hand-off and removes a message link
// token from the address bar before any other module reads the URL.
import "./Common/Tracking/utils/visitorScript";
import "react-native-gesture-handler";
import { registerRootComponent } from "expo";
import { initTelemetry } from "./Common/Telemetry/boot";
import { installChunkErrorReloadHandler } from "./Common/Updates/utils/chunkReload";
import { configureDotLottieWasm } from "./Common/Lottie/utils/dotLottieWasm";

// Register before the dynamic import below so a stale-chunk failure loading the
// app itself (after a redeploy) is caught and recovered with a single reload.
installChunkErrorReloadHandler();

// Serve the Lottie WASM from our own origin before anything renders a Lottie,
// so no loader fetches it from cdn.jsdelivr.net ahead of tracking consent.
configureDotLottieWasm();

// eslint-disable-next-line no-undef
if (!__DEV__) {
  initTelemetry();
}

const PatientApp = (await import("./PatientApp/PatientApp")).default;

registerRootComponent(PatientApp);
